import './AppHeader.css';
import * as React from "react";

export default class AppHeader extends React.Component {
    render() {
        return (
            <header className="app-header">
                <div className="left-header">Keuze hulp</div>
                <div className="right-header">{this.props.title}</div>
            </header>
        );
    }
}
